import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  style: {
                height: `520px`,
            },
  class: "ofs"
}
const _hoisted_2 = { class: "w100 pad40" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "title mc" }, [
  /*#__PURE__*/_createElementVNode("p", {
    class: "header_title fs24 centered",
    style: {"color":"#696969"}
  }, "リマインドする")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_5 = {
  key: 0,
  class: "fw400 fs13"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "ml10" }, "リマインドしたいメッセージを入力できます。", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_10 = {
  key: 1,
  class: "w100 mb40",
  style: {"height":"40px"}
}
const _hoisted_11 = {
  class: /*#__PURE__*/_normalizeClass(`fs12 fl pointer pad8`),
  style: {"width":"300px"}
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", {
  for: `show_possible_dates_`,
  class: "fs12 pointer"
}, " 提案候補日程を表示する（未確定の場合のみ）", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_14 = {
  class: "w100 posAb",
  style: {"bottom":"0"}
}
const _hoisted_15 = {
  class: "posAb w50 centered",
  style: {"left":"0","bottom":"0"}
}
const _hoisted_16 = { class: "fs14 fw400" }
const _hoisted_17 = {
  class: "posAb w50 centered",
  style: {"right":"0","bottom":"0"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_md_progress_bar = _resolveComponent("md-progress-bar")!
  const _component_RoomLightOverViewContent = _resolveComponent("RoomLightOverViewContent")!
  const _component_AddCommentToMail = _resolveComponent("AddCommentToMail")!
  const _component_CheckboxTag = _resolveComponent("CheckboxTag")!
  const _component_VueFinalModal = _resolveComponent("VueFinalModal")!

  return (_openBlock(), _createBlock(_component_VueFinalModal, {
    "modal-id": "RemindModal",
    "content-class": "modalContent shadowContent rad10 modalStandard",
    onBeforeOpen: _ctx.openModal
  }, {
    default: _withCtx(() => [
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_md_progress_bar, { key: 0 }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _hoisted_4,
          (_ctx.from == `rooms` && _ctx.selectedRooms && _ctx.selectedRooms.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(_component_RoomLightOverViewContent, {
                  room: _ctx.selectedRooms[0],
                  appo: _ctx.selectedRooms[0]?.current_appointment
                }, null, 8, ["room", "appo"])
              ]))
            : _createCommentVNode("", true),
          _hoisted_6,
          _hoisted_7,
          _hoisted_8,
          _createVNode(_component_AddCommentToMail, {
            ref: "AddCommentToMail",
            class: "mt20",
            tmp: _ctx.tmp,
            showSubject: true,
            hideButtons: true,
            onInputMemo: _ctx.inputMessage,
            onInputSubject: _ctx.inputSubject
          }, null, 8, ["tmp", "onInputMemo", "onInputSubject"]),
          _hoisted_9,
          false
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_CheckboxTag, {
                    value: ``,
                    name: `show_possible_dates`,
                    checked: _ctx.showPossibleDates,
                    prefix: `show_possible_dates`,
                    onClickCheckbox: _ctx.clickShowPossibleDates,
                    class: "ml1"
                  }, null, 8, ["checked", "onClickCheckbox"]),
                  _hoisted_12
                ]),
                _hoisted_13
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("section", {
            class: "with_white_bg dgrey fs16 pointer centered llgreyBg",
            style: {"line-height":"50px","height":"50px"},
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.cancelInput && _ctx.cancelInput(...args)))
          }, [
            _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t(`title.close`)), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("section", null, [
            _createElementVNode("div", {
              class: "w100 skyblueBg fs16 pointer centered fw600",
              style: {"line-height":"50px","height":"50px"},
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.send && _ctx.send(...args)))
            }, " リマインドを送信 ")
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["onBeforeOpen"]))
}